import { useSyncExternalStore } from 'react';

import { IPanorama } from '@ael/core-api';

export const useSyncSceneIndexChanged = (panorama: IPanorama) => {
  return useSyncExternalStore(panorama.subscribeVirtualTourChanged, panorama.getActiveSceneIndex);
};
